export const actions = {
    SET_LOCATION: 'SET_LOCATION',
    SET_ACTUAL_LOCATION: 'SET_ACTUAL_LOCATION',

    RESET_STATE: 'RESET_STATE',
    SET_ZOOM: 'SET_ZOOM',
    SET_SCREEN: 'SET_SCREEN',
}